export const CUSTOM_LAYOUT_PATH = ["/studio", "/preview"];

export const HEADER_LAYOUT = ["/scenes", "/ai-scenes", "/generate", "/text-summarization"];

export const NO_HEADER_SIDENAV_ROUTES = [
  "/chatbot",
  "/create/generate",
  "/create/url",
  "/create/text",
  "/storyboard",
  "/create",
  "/canvas",
  "/canvas/ai",
  "/canvas/url",
  "/canvas/text",
  "/canvas/analyze",
  "/canvas/",
  "/canvas/create",
];